<script>
	import Sidebar from './Sidebar.svelte'
	import ContactInfo from './Contact/Info.svelte';
	import ContactTimeline from './Contact/Timeline.svelte';
	import Contact from '../States/Contact';
	import Router from '../States/Router';

	const data = $Router.data;
	let contact = {};
	let timeline = [];

	async function init() {
		if(data?.id) {
			const response = await Contact.get(data.id);
			if(response.success) {
				contact = response.contact;
				timeline = response.timeline;
			}
		}
	}

	function call() {
		Router.component('conference', {call: true, contact: true, contactId: data.id})
	}

	init();

</script>

<div class="container-fluid">
	<div class="wrapper">
		<Sidebar/>
		<div class="content-page">
			<div class="content">
				<div class="row">
					<div class="col-12">
						<div class="page-title-box">
							<h4 class="page-title">Contact</h4>
						</div>
					</div>
				</div>

				<div class="row">
					<div id="contact-info" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
						<ContactInfo on:call={call} bind:contact={contact} bind:editing={data.edit}/>
					</div>

					<div id="contact-timeline" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
						<ContactTimeline bind:timeline={timeline}/>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
